function getValues(store) {
  const state = store.getState();
  const accessToken = state.getIn(['account', 'accessToken']);
  const deviceId = state.getIn(['device', 'deviceId']);
  return { accessToken, deviceId };
}

function isAllowedPassed(store) {
  return !(store.getState().getIn(['persist', 'inProgress']));
}

export function isAuthenticated(store) {
  return (router, redirect) => {
    if (!isAllowedPassed(store)) {
      redirect('/');
      return;
    }
    const { accessToken, deviceId } = getValues(store);
    if (!accessToken || !deviceId) {
      redirect('welcome');
    }
  };
}

export function isNotAuthenticated(store) {
  return (router, redirect) => {
    if (!isAllowedPassed(store)) {
      redirect('/');
      return;
    }
    const { accessToken, deviceId } = getValues(store);
    if (accessToken && deviceId) {
      redirect('timeclock');
    }
  };
}

export function shouldViewLoader(store) {
  return (router, redirect) => {
    if (isAllowedPassed(store)) {
      redirect('/timeclock');
    }
  };
}



// WEBPACK FOOTER //
// ./src/lib/router/index.js